import { useRef, useEffect, useState } from "react";
import {
  ProjectWrapper,
  SectionEightWrapper,
  SectionFifteenWrapper,
  SectionFourWrapper,
  SectionOneWrapper,
  SectionSeventeenWrapper,
  SectionSevenWrapper,
  SectionThirteenWrapper,
  SectionThreeWrapper,
  SectionTwoWrapper,
} from "./styled";

import {
  Box,
  Grid,
  IconButton,
  Theme,
  Typography,
  Dialog,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { East, Add, Remove } from "@mui/icons-material";
import { useLocation } from "react-router-dom";

import SmileIcon from "../../Assets/Icons/SmileIcon";
import CircleIcon from "../../Assets/Icons/CircleIcon";
import TriangleIcon from "../../Assets/Icons/TriangleIcon";
import SqaureIcon from "../../Assets/Icons/SqaureIcon";
import Lines from "../../Assets/Icons/Lines";
import withAuth from "../../HOC/withAuth";
import { scrollTrigger } from "../../Helper/scrollAnimation";

// Zillion Skills screens
import ZS1 from "../../Assets/images/zs1.png";
import ZS2 from "../../Assets/images/zs2.png";
import ZS3 from "../../Assets/images/zs3.png";
import ZS4 from "../../Assets/images/zs4.png";
import ZS5 from "../../Assets/images/zs5.png";
import ZS6 from "../../Assets/images/zs6.png";
import ZS7 from "../../Assets/images/zs7.png";
import ZS8 from "../../Assets/images/zs8.png";
import ZS9 from "../../Assets/images/zs9.png";
import PsychometricVideo from "../../Assets/images/psychometric_test.mp4";
import PersonalizationVideo from "../../Assets/images/personalization.mp4";
import ZS20 from "../../Assets/images/zs20.png";
import DailyChallengeVideo from "../../Assets/images/daily_challenge.mp4";
import Community1 from "../../Assets/images/community1.png";
import Community2 from "../../Assets/images/community2.png";
import ZS30 from "../../Assets/images/zs30.png";
import ZS31 from "../../Assets/images/zs31.png";
import ZS32 from "../../Assets/images/zs32.png";
import ZS33 from "../../Assets/images/zs33.png";
import ZS34 from "../../Assets/images/zs34.png";
import ZS35 from "../../Assets/images/zs35.png";
import ZS36 from "../../Assets/images/zs36.png";
import WorkshopsVideo from "../../Assets/images/workshop.mp4";
import ZS40 from "../../Assets/images/zs40.png";
import ZS41 from "../../Assets/images/zs41.png";
import ZS42 from "../../Assets/images/zs42.png";
import ZS43 from "../../Assets/images/zs43.png";
import ZS50 from "../../Assets/images/zs50.png";
import ZS51 from "../../Assets/images/zs51.png";
import ZS52 from "../../Assets/images/zs52.png";
import ZS53 from "../../Assets/images/zs53.png";
import ZSH1 from "../../Assets/images/zs_hero_1.png";
import ZSH2 from "../../Assets/images/zs_hero_2.png";
import ZSH3 from "../../Assets/images/zs_hero_3.png";
import ZSH4 from "../../Assets/images/zs_hero_4.png";
import ZSH5 from "../../Assets/images/zs_hero_5.png";
import ZSH6 from "../../Assets/images/zs_hero_6.png";
import ZSH7 from "../../Assets/images/zs_hero_7.png";
import ZSH8 from "../../Assets/images/zs_hero_8.png";
import ZSH9 from "../../Assets/images/zs_hero_9.png";

// User journeys (placeholders — swap in your actual exports)
import ZS10 from "../../Assets/images/zs10.png";
import ZS11 from "../../Assets/images/zs11.png";
import ZS12 from "../../Assets/images/zs12.png";
import ZS13 from "../../Assets/images/zs13.png";

// ─────────────────────────────────────────────────────────────
// ZILLION SKILLS IMAGE SOURCES
// Update these paths to your local assets if you have them bundled.
// The s3 links you shared are kept where available; others are placeholders.
// ─────────────────────────────────────────────────────────────
const heroScreens = [ZSH3, ZSH4, ZSH1, ZSH2, ZSH5, ZSH6, ZSH7, ZSH8, ZSH9];

const Project4 = () => {
  const { pathname } = useLocation();

  // ─── State ─────────────────────────────────────────────────
  const [expandedItems, setExpandedItems] = useState<Record<string, boolean>>(
    {}
  );
  const [zoomSrc, setZoomSrc] = useState<string | null>(null);

  const communitySteps = [
    { img: Community1, label: "ZillSkill Club feed — kids share projects" },
    { img: Community2, label: "Profile with safe moderation" },
  ];
  const [communityStep, setCommunityStep] = useState(0);

  // NEW: stepper state
  const steps = [
    {
      img: ZS2,
      label:
        "Mapped the journey of a kid in collab with 12 year-old testers and parents, to understand touch points and opportunities for engagement at every step",
    },
    { img: ZS3, label: "Opportunities this journey brings up" },
    { img: ZS4, label: "User Journey around course experience for a kid" },
    { img: ZS5, label: "Opportunities this journey brings up" },
  ];
  const [activeStep, setActiveStep] = useState(0);

  // Rewards slideshow (7 images)
  const rewardsSteps = [
    { img: ZS30, label: "Earn Rocket Fuel points for completing challenges" },
    { img: ZS31, label: "Level up with streaks and milestone badges" },
    { img: ZS32, label: "Redeem points for workshop discounts" },
    { img: ZS33, label: "Track progress across skills and interests" },
    { img: ZS34, label: "Workshop completions unlock special badges" },
    { img: ZS35, label: "Dashboard shows goals, streaks, and rewards" },
    { img: ZS36, label: "Tutor-verified submissions grant bonus points" },
  ];

  const [rewardsStep, setRewardsStep] = useState(0);

  const kidsDashboardSteps = [
    { img: ZS40, label: "Dashboard home" },
    { img: ZS41, label: "Workshop progress" },
    { img: ZS42, label: "Interests selection" },
    { img: ZS43, label: "Enrolled workshops" },
  ];

  const [kidsDashboardStep, setKidsDashboardStep] = useState(0);

  const tutorDashboardSteps = [
    { img: ZS50, label: "Tutor dashboard with start reminder" },
    { img: ZS51, label: "In-progress session homepage" },
    { img: ZS52, label: "Review student submissions" },
    { img: ZS53, label: "Tutor dashboard" },
  ];

  const [tutorDashboardStep, setTutorDashboardStep] = useState(0);

  // keep a ref just in case styled wrappers rely on effects
  const visualizerRef = useRef<HTMLCanvasElement>(null);

  const toggleExpanded = (key: string) =>
    setExpandedItems((p) => ({ ...p, [key]: !p[key] }));

  // ─── Effects ───────────────────────────────────────────────
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://t.contentsquare.net/uxa/bb781a00c0c07.js";
    script.async = true;
    document.head.appendChild(script);
  
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  

  useEffect(() => {
    const onScroll = () => scrollTrigger(".lineAnimation");
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!zoomSrc) return;
      const idx = heroScreens.indexOf(zoomSrc);
      if (idx === -1) return;

      if (["ArrowLeft", "ArrowUp"].includes(event.key)) {
        event.preventDefault();
        const prev = idx > 0 ? idx - 1 : heroScreens.length - 1;
        setZoomSrc(heroScreens[prev]);
      }
      if (["ArrowRight", "ArrowDown"].includes(event.key)) {
        event.preventDefault();
        const next = idx < heroScreens.length - 1 ? idx + 1 : 0;
        setZoomSrc(heroScreens[next]);
      }
      if (event.key === "Escape") {
        event.preventDefault();
        setZoomSrc(null);
      }
    };

    if (zoomSrc) window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [zoomSrc]);

  // ─── Render ────────────────────────────────────────────────
  return (
    <ProjectWrapper>
      {/* ─────────────────── HERO ─────────────────── */}
      <Box
        sx={{
          position: "fixed",
          width: "1px",
          height: "1px",
          background: (theme: Theme) => theme.palette.primary.main,
          top: 0,
          zIndex: 999999999999,
          left: 0,
          borderRadius: "100%",
          animation: "animateCircle1 0.5s",
          animationIterationCount: 1,
          "@keyframes animateCircle1": {
            from: { transform: "scale(4000)" },
            to: { transform: "scale(0)" },
          },
        }}
      />
      <SectionOneWrapper>
        <Typography variant="h1">ZILLSKILL</Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: { sm: "row", xs: "column" },
            "& p": {
              fontWeight: 500,
              fontSize: { md: "28px", xs: "22px" },
            },
          }}
        >
          <Typography>
            PERSONALIZED HOBBY DISCOVERY FOR KIDS (AGED 6–12)
          </Typography>
        </Box>
      </SectionOneWrapper>

      {/* ─────────────────── SCREENS STRIP (Zoomable) ─────────────────── */}
      <SectionTwoWrapper>
        <Box
          sx={{
            display: "flex",
            overflowX: "auto",
            scrollSnapType: "x mandatory",
            "&::-webkit-scrollbar": { display: "none" },
            "& img": {
              height: { lg: 520, md: 420, sm: 320, xs: 220 }, // ⬆️ taller across breakpoints
              width: "auto",
              objectFit: "cover", // fills the taller thumb nicely
              borderRadius: "12px",
              boxShadow: "4px 0px 20px 0px #66666640",
              cursor: "pointer",
            },

            "& > div": {
              flex: "0 0 auto",
              mr: 2,
              scrollSnapAlign: "start",
            },
          }}
        >
          {heroScreens.map((src) => (
            <Box key={src} onClick={() => setZoomSrc(src)}>
              <img src={src} alt="ZS screen" />
            </Box>
          ))}
        </Box>
      </SectionTwoWrapper>

      {/* ─── ZOOM DIALOG ─────────────────────────────────────────────── */}
      <Dialog
        open={Boolean(zoomSrc)}
        onClose={() => setZoomSrc(null)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: { background: "transparent", boxShadow: "none" },
        }}
      >
        <Box sx={{ position: "relative" }}>
          <IconButton
            onClick={() => setZoomSrc(null)}
            sx={{ position: "absolute", top: 8, right: 8, zIndex: 1 }}
          >
            <CloseIcon />
          </IconButton>
          {zoomSrc && (
            <img
              src={zoomSrc}
              alt="zoomed screen"
              style={{ width: "100%", height: "auto", borderRadius: "12px" }}
            />
          )}
        </Box>
      </Dialog>

      {/* ─────────────────── TL;DR + Mission ─────────────────── */}
      <SectionThreeWrapper id="section1">
        {/* TL;DR */}
        <Box>
          <Typography
            variant="h3"
            sx={{ fontSize: { md: "28px", xs: "22px" }, fontWeight: 700 }}
          >
            TL;DR
          </Typography>

          <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 2.5 }}>
            Kids in India rarely get to explore hobbies outside academics. I led
            end-to-end product design for ZillSkill (ZS) - a platform built to
            make hobby discovery fun, personalized, and sustainable.
          </Typography>

          <Box
            sx={{
              py: 3.5,
              px: 4,
              mt: 6,
              background: (theme: Theme) => theme.palette.secondary.main,
            }}
          >
            <Typography
              sx={{
                fontSize: { md: "22px", xs: "20px" },
                fontWeight: 600,
                lineHeight: "33.89px",
              }}
            >
              <ul>
                <li>
                  My role: Balanced design, PM, and strategy while working with
                  founders + engineers
                </li>
                <li>Team: 2 Engineers, Founders, Child Psychologist</li>
                <li>Device: Responsive web (desktop-first)</li>
                <li>Key metric: 7-day repeat rate for signed-in kids</li>
              </ul>
            </Typography>
          </Box>
        </Box>

        {/* Problem */}
        <Box sx={{ mt: 10 }}>
          <Typography
            variant="h3"
            sx={{ fontSize: { md: "28px", xs: "22px" }, fontWeight: 700 }}
          >
            The Problem
          </Typography>

          <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 2.5 }}>
            In India, extracurricular exploration is rare. Schools focus heavily
            on academics, leaving kids with little room to try hobbies that
            might spark lifelong passions.
          </Typography>

          <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 2.5 }}>
            The founders of ZillSkill wanted to change that. Their mission:
          </Typography>

          <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 2.5 }}>
            <strong>
              A personalized platform where kids could explore any hobby, from
              art to robotics.
            </strong>{" "}
          </Typography>

          <Typography
            variant="h3"
            sx={{
              fontSize: { md: "28px", xs: "22px" },
              fontWeight: 700,
              mt: 6,
            }}
          >
            My Challenge
          </Typography>

          <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 2 }}>
            <strong>Balance three competing needs</strong>
            <br></br>
            <ul>
              <li>Kids want fun and novelty (daily challenges, rewards).</li>
              <li>
                Parents want safety and trust (psychologist-designed test,
                transparent dashboards).
              </li>
              <li>
                Tutors need efficiency (simplified dashboards, progress
                tracking)
              </li>
            </ul>
          </Typography>
        </Box>

        {/* My Approach */}
        <Box sx={{ mt: 10 }} id="section2">
          <Typography
            variant="h3"
            sx={{
              fontSize: { md: "40px", sm: "32px", xs: "28px" },
              fontWeight: 700,
              fontFamily: "Mohave",
              fontStyle: "italic",
            }}
          >
            MY APPROACH{" "}
          </Typography>

          <Box
            sx={{
              py: 3.5,
              px: 4,
              mt: 6,
              background: (theme: Theme) => theme.palette.secondary.main,
            }}
          >
            <Typography
              sx={{ fontSize: { md: "22px", xs: "20px" }, fontWeight: 400 }}
            >
              I combined{" "}
              <strong>
                competitive analysis, behavioral models, and expert input (child
                psychologist)
              </strong>{" "}
              to shape the product.
              <br></br>
              <br></br>
              <strong>Analyzed DIY.org:</strong> Made a strong first impression
              with colorful illustrations, challenges, and badges. However, the
              content felt fairly static and personalization options were
              limited.
              <br></br>
              <br></br>
              <strong>Read Hooked by Nir Eyal:</strong> Reinforced the
              importance of habit loops and variable rewards in sustaining
              engagement, which shaped my approach to daily challenges and
              recognition systems.
              <br></br>
              <br></br>
              <strong>Psychologist-led workshop:</strong> Helped shape the
              psychometric test and confirmed that kids respond best to novelty,
              recognition, and short, repeatable activities tailored to their
              age.
            </Typography>
          </Box>
        </Box>
      </SectionThreeWrapper>

      {/* User Journeys */}
      <SectionSevenWrapper>
        <Typography
          variant="h2"
          sx={{
            fontSize: { md: "28px", xs: "22px" },
            fontWeight: 700,
            lineHeight: "33.89px",
          }}
        >
          How would a kid in the age of 6-12 even find us?
        </Typography>

        <Box
          sx={{
            mt: 2,
            position: "relative",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {/* Fixed container to keep all images same size */}
          <Box
            sx={{
              width: "100%",
              maxWidth: { xl: 1100, lg: 1000, md: 900 },
              aspectRatio: "16 / 9", // uniform size for all
              overflow: "hidden",
              boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
              bgcolor: "#fff", // background fill for letterboxing
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={steps[activeStep].img}
              alt={steps[activeStep].label}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain", // show full image, no crop
              }}
            />
          </Box>

          {/* Circular nav controls bottom-right */}
          <Box
            sx={{
              position: "absolute",
              right: 12,
              bottom: 12,
              display: "flex",
              gap: 1,
            }}
          >
            <IconButton
              aria-label="Previous"
              onClick={() =>
                setActiveStep((prev) =>
                  prev === 0 ? steps.length - 1 : prev - 1
                )
              }
              sx={{
                width: 44,
                height: 44,
                borderRadius: "50%",
                bgcolor: "rgba(0,0,0,0.6)",
                color: "#fff",
                "&:hover": { bgcolor: "rgba(0,0,0,0.75)" },
              }}
            >
              <East sx={{ transform: "rotate(180deg)" }} />
            </IconButton>
            <IconButton
              aria-label="Next"
              onClick={() =>
                setActiveStep((prev) =>
                  prev === steps.length - 1 ? 0 : prev + 1
                )
              }
              sx={{
                width: 44,
                height: 44,
                borderRadius: "50%",
                bgcolor: "rgba(0,0,0,0.6)",
                color: "#fff",
                "&:hover": { bgcolor: "rgba(0,0,0,0.75)" },
              }}
            >
              <East />
            </IconButton>
          </Box>
        </Box>

        {/* Caption */}
        <Typography
          sx={{
            mt: 2,
            textAlign: "center",
            fontSize: { md: "20px", xs: "16px" },
            fontWeight: 600,
          }}
        >
          {steps[activeStep].label}
        </Typography>
        <br></br>
        <br></br>

        {/* <Box sx={{ mt: 5 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { md: "28px", xs: "22px" },
              fontWeight: 700,
              lineHeight: "33.89px",
            }}
          >
            Some observations
          </Typography>

          <Box component="ul" sx={{ mt: 2, pl: 0, listStyle: "none" }}>
            <Box
              component="li"
              sx={{ display: "flex", alignItems: "flex-start", mb: 1.5 }}
            >
              <East sx={{ mt: "2px", color: "#00C853" }} />
              <Typography
                sx={{
                  ml: 1,
                  fontSize: { md: "22px", xs: "20px" },
                  fontWeight: 400,
                  color: "#000",
                }}
              >
                Kid's journey will always have boredom risk and will need
                novelty.
              </Typography>
            </Box>

            <Box
              component="li"
              sx={{ display: "flex", alignItems: "flex-start", mb: 1.5 }}
            >
              <East sx={{ mt: "2px", color: "#00C853" }} />
              <Typography
                sx={{
                  ml: 1,
                  fontSize: { md: "22px", xs: "20px" },
                  fontWeight: 400,
                  color: "#000",
                }}
              >
                Parents do not trust platforms especially if their kids are
                minors.
              </Typography>
            </Box>
          </Box>
        </Box> */}

        <Box sx={{ mt: 5 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { md: "28px", xs: "22px" },
              fontWeight: 700,
              lineHeight: "33.89px",
            }}
          >
            Insights that shaped the solution
          </Typography>

          <Box component="ul" sx={{ mt: 2, pl: 0, listStyle: "none" }}>
            <Box
              component="li"
              sx={{ display: "flex", alignItems: "flex-start", mb: 1.5 }}
            >
              <East sx={{ mt: "2px", color: "#00C853" }} />
              <Typography
                sx={{
                  ml: 1,
                  fontSize: { md: "22px", xs: "20px" },
                  fontWeight: 400,
                  color: "#000",
                }}
              >
                <b>Kids get bored quickly</b> → daily novelty (challenges, fun
                facts) keeps engagement alive.
              </Typography>
            </Box>

            <Box
              component="li"
              sx={{ display: "flex", alignItems: "flex-start", mb: 1.5 }}
            >
              <East sx={{ mt: "2px", color: "#00C853" }} />
              <Typography
                sx={{
                  ml: 1,
                  fontSize: { md: "22px", xs: "20px" },
                  fontWeight: 400,
                  color: "#000",
                }}
              >
                <b>Parents worry about trust & safety</b> → psychologist-led
                test + transparent dashboards built confidence.
              </Typography>
            </Box>

            <Box
              component="li"
              sx={{ display: "flex", alignItems: "flex-start", mb: 1.5 }}
            >
              <East sx={{ mt: "2px", color: "#00C853" }} />
              <Typography
                sx={{
                  ml: 1,
                  fontSize: { md: "22px", xs: "20px" },
                  fontWeight: 400,
                  color: "#000",
                }}
              >
                <b>Community motivates kids</b> → safe peer feedback spaces
                encourage sharing and recognition. rewarding.
              </Typography>
            </Box>

            <Box
              component="li"
              sx={{ display: "flex", alignItems: "flex-start" }}
            >
              <East sx={{ mt: "2px", color: "#00C853" }} />
              <Typography
                sx={{
                  ml: 1,
                  fontSize: { md: "22px", xs: "20px" },
                  fontWeight: 400,
                  color: "#000",
                }}
              >
                <b>
                  While tutors weren’t the primary users, their efficiency
                  mattered
                </b>{" "}
                → simple dashboards reduced overhead without distracting from
                the kid-parent experience.
              </Typography>
            </Box>
          </Box>
        </Box>
      </SectionSevenWrapper>

      {/* ─────────────────── Design Strategy: 3 Layers / 8 Levers ─────────────────── */}
      <SectionEightWrapper id="section3">
        <Typography
          variant="h3"
          sx={{
            fontSize: { md: "40px", sm: "32px", xs: "28px" },
            fontWeight: 700,
            fontFamily: "Mohave",
            fontStyle: "italic",
          }}
        >
          DESIGN STRATEGY: 9 PILLARS ACROSS 3 LAYERS
        </Typography>

        <Typography
          sx={{
            fontSize: { md: "22px", sm: "18px" },
            fontWeight: 400,
            color: "black",
            mt: 3,
          }}
        >
          To encourage exploration and long-term growth, I structured ZS around
          <b> Personalization</b>, <b>Engagement</b>, and <b>Trust</b>. Each
          layer had pillars tied to outcomes.
        </Typography>

        {/* Layer 1: Personalization */}
        <Box sx={{ mt: 4 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mt: 1,
              "& div": {
                fontSize: { md: "22px", sm: "18px" },
                fontWeight: 700,
                color: "#000",
                whiteSpace: "nowrap",
              },
            }}
          >
            <br></br>
            <Box
              sx={{ py: 2, px: 3, background: (t) => t.palette.secondary.main }}
            >
              Layer 1 - Personalization
            </Box>
          </Box>

          <Box sx={{ mt: 2 }}>
            <Typography
              sx={{ fontWeight: 700, fontSize: { md: "22px", xs: "20px" } }}
            >
              <br></br>
              Personalization → Turn curiosity into exploration
            </Typography>
            <Typography
              sx={{
                mt: 1,
                fontSize: { md: "22px", xs: "20px" }, // match size
                fontWeight: 400, // match weight
                color: "#000", // force black
              }}
            >
              Kids select interests; homepage tailors hobbies, workshops, and
              content.
            </Typography>
            <Box
              sx={{
                mt: 2,
                maxWidth: "900px",
                border: "1px solid #e0e0e0",
                overflow: "hidden",
                "& video": {
                  width: "100%",
                  height: "auto",
                  display: "block",
                  objectFit: "contain",
                },
              }}
            >
              <video
                src={PersonalizationVideo}
                autoPlay
                loop
                muted
                playsInline
              />
            </Box>
          </Box>
          <br></br>
          <br></br>
          <br></br>
          {/* CTA in between the two Personalization points */}
          <Typography
            sx={{
              mt: 3,
              fontWeight: 700,
              fontSize: { md: "22px", xs: "20px" },
            }}
          >
            CTA — “Tell me what I am good at”
          </Typography>
          <Typography
            sx={{
              mt: 1,
              fontSize: { md: "22px", xs: "20px" }, // match size
              fontWeight: 400, // match weight
              color: "#000", // force black
            }}
          >
            This CTA lives inside the workshops filter. If kids aren’t sure what
            to select, it guides them into a quick psychometric test we built
            with a child psychologist. The results suggest hobbies and workshops
            worth trying, based on their personality markers.
          </Typography>

          <Box
            sx={{
              mt: 2,
              maxWidth: "900px",
              border: "1px solid #e0e0e0",
              overflow: "hidden",
              "& img": {
                width: "100%",
                height: "auto",
                display: "block",
                objectFit: "contain", // no cropping
              },
            }}
          >
            <img src={ZS20} alt="“Tell me what I’m good at” CTA" />
          </Box>
          <br></br>
          <br></br>
          <Typography
            sx={{
              mt: 3,
              fontWeight: 700,
              fontSize: { md: "22px", xs: "20px" },
            }}
          >
            Psychometric Test → Reveal hidden strengths
          </Typography>
          <Typography
            sx={{
              mt: 1,
              fontSize: { md: "22px", xs: "20px" }, // match size
              fontWeight: 400, // match weight
              color: "#000", // force black
            }}
          >
            Co-designed with a child psychologist; suggests hobbies aligned to
            personality and abilities.
          </Typography>

          <Box
            sx={{
              mt: 2,
              maxWidth: "900px",
              border: "1px solid #e0e0e0",
              overflow: "hidden",
              "& video": {
                width: "100%",
                height: "auto",
                display: "block",
                objectFit: "contain", // no crop
              },
            }}
          >
            <video src={PsychometricVideo} autoPlay loop muted playsInline />
          </Box>
        </Box>
        <br></br>

        <br></br>
        <br></br>
        <Box
          sx={{
            py: 2,
            px: 2.5,
            mt: 2,
            background: (theme: Theme) => theme.palette.secondary.main,
            fontSize: { md: "16px", sm: "15px" },
            fontWeight: 600,
            fontFamily: "DM Sans",
          }}
        >
          <Typography
            sx={{
              mt: 1,
              fontSize: { md: "22px", xs: "20px" }, // match size
              fontWeight: 400, // match weight
              color: "#000", // force black
            }}
          >
            Personalization started with interest selection, giving kids a sense
            of agency by letting them shape their own discovery path.<br></br>
            <br></br>For those who felt unsure, the “Tell me what I am good at”
            CTA bridges the uncertainty by mapping personality markers to
            suggested workshops.
            <br></br>
            <br></br>To keep curiosity alive, hooks like “Fun Facts” and
            end-of-blog nudges (“Workshops you might like”) turned exploration
            into momentum (not shown above), seamlessly guiding kids from
            browsing into meaningful engagement and sign-ups.
            <br></br>
            <br></br>
          </Typography>
        </Box>
        <br></br>
        <br></br>
        {/* Layer 2: Engagement */}
        <Box sx={{ mt: 6 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mt: 1,
              "& div": {
                fontSize: { md: "22px", sm: "18px" },
                fontWeight: 700,
                color: "#000",
                whiteSpace: "nowrap",
              },
            }}
          >
            <Box
              sx={{ py: 2, px: 3, background: (t) => t.palette.secondary.main }}
            >
              Layer 2 - Engagement
            </Box>
          </Box>
          <br></br>
          <Box
            sx={{
              py: 2,
              px: 2.5,
              mt: 2,
              background: (theme: Theme) => theme.palette.secondary.main,
              fontSize: { md: "16px", sm: "15px" },
              fontWeight: 600,
              fontFamily: "DM Sans",
            }}
          >
            <Typography
              sx={{
                mt: 1,
                fontSize: { md: "22px", xs: "20px" }, // match size
                fontWeight: 400, // match weight
                color: "#000", // force black
              }}
            >
              Every engagement feature - daily challenges, ZillSkill Club, and
              the rewards system was designed and evaluated against our key
              metric: would this encourage kids to return within seven days?
              <br></br>
            </Typography>
          </Box>
          <br></br>
          <Typography
            sx={{
              mt: 2,
              fontWeight: 700,
              fontSize: { md: "22px", xs: "20px" },
            }}
          >
            Daily Challenges → Build repeat engagement
          </Typography>
          <Typography
            sx={{
              mt: 1,
              fontSize: { md: "22px", xs: "20px" }, // match size
              fontWeight: 400, // match weight
              color: "#000", // force black
            }}
          >
            Lightweight puzzles refreshed daily; streaks and rewards made
            engagement sticky.
          </Typography>
          <Box
            sx={{
              mt: 2,
              maxWidth: "900px",
              border: "1px solid #e0e0e0",
              overflow: "hidden",
              "& video": {
                width: "100%",
                height: "auto",
                display: "block",
                objectFit: "contain", // no crop
              },
            }}
          >
            <video src={DailyChallengeVideo} autoPlay loop muted playsInline />
          </Box>
          <br></br>
          <br></br>
          <Typography
            sx={{
              mt: 3,
              fontWeight: 700,
              fontSize: { md: "22px", xs: "20px" },
            }}
          >
            Community (ZillSkill Club) → Motivate through safe peer feedback
          </Typography>
          <Typography
            sx={{
              mt: 1,
              fontSize: { md: "22px", xs: "20px" }, // match size
              fontWeight: 400, // match weight
              color: "#000", // force black
            }}
          >
            A moderated space where kids share creations, get feedback, and stay
            inspired.
          </Typography>
          <Box
            sx={{
              mt: 2,
              position: "relative",
              // display: "flex",           // remove
              // justifyContent: "center",  // remove
            }}
          >
            <Box
              sx={{
                maxWidth: "900px",
                width: "100%",
                aspectRatio: "16 / 9", // 🔑 forces consistent size

                border: "1px solid #e0e0e0",
                overflow: "hidden",
                "& img": {
                  width: "100%",
                  height: "auto",
                  bgcolor: "#000", // background for letterbox space

                  display: "block",
                  objectFit: "contain",
                },
              }}
            >
              <img
                src={communitySteps[communityStep].img}
                alt={communitySteps[communityStep].label}
              />
            </Box>

            {/* Bottom-right arrows */}
            <Box
              sx={{
                position: "absolute",
                right: 12,
                bottom: 12,
                display: "flex",
                gap: 1,
              }}
            >
              <IconButton
                aria-label="Previous"
                onClick={() =>
                  setCommunityStep((prev) =>
                    prev === 0 ? communitySteps.length - 1 : prev - 1
                  )
                }
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "50%",
                  bgcolor: "rgba(0,0,0,0.6)",
                  color: "#fff",
                  "&:hover": { bgcolor: "rgba(0,0,0,0.75)" },
                }}
              >
                <East sx={{ transform: "rotate(180deg)" }} />
              </IconButton>
              <IconButton
                aria-label="Next"
                onClick={() =>
                  setCommunityStep((prev) =>
                    prev === communitySteps.length - 1 ? 0 : prev + 1
                  )
                }
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "50%",
                  bgcolor: "rgba(0,0,0,0.6)",
                  color: "#fff",
                  "&:hover": { bgcolor: "rgba(0,0,0,0.75)" },
                }}
              >
                <East />
              </IconButton>
            </Box>
          </Box>

          {/* Caption */}
          <Typography
            sx={{
              mt: 2,
              textAlign: "center",
              fontSize: { md: "18px", xs: "16px" },
              fontWeight: 500,
            }}
          >
            {communitySteps[communityStep].label}
          </Typography>

          <br></br>
          <br></br>
          <Typography
            sx={{
              mt: 3,
              fontWeight: 700,
              fontSize: { md: "22px", xs: "20px" },
            }}
          >
            Rewards → Reinforce long-term growth
          </Typography>
          <Typography
            sx={{
              mt: 1,
              fontSize: { md: "22px", xs: "20px" }, // match size
              fontWeight: 400, // match weight
              color: "#000", // force black
            }}
          >
            “Rocket Fuel Points” + badges turned progress into visible
            achievements and encouraged consistency.
          </Typography>
          <Box
            sx={{
              mt: 2,
              position: "relative",
              // display: "flex",           // remove
              // justifyContent: "center",  // remove
            }}
          >
            <Box
              sx={{
                maxWidth: "900px",
                width: "100%",
                aspectRatio: "16 / 9",
                border: "1px solid #e0e0e0",
                overflow: "hidden",
                bgcolor: "#fff",
                "& img": {
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  display: "block",
                },
              }}
            >
              <img
                src={rewardsSteps[rewardsStep].img}
                alt={rewardsSteps[rewardsStep].label}
              />
            </Box>

            {/* Bottom-right arrows */}
            <Box
              sx={{
                position: "absolute",
                right: 12,
                bottom: 12,
                display: "flex",
                gap: 1,
              }}
            >
              <IconButton
                aria-label="Previous"
                onClick={() =>
                  setRewardsStep((prev) =>
                    prev === 0 ? rewardsSteps.length - 1 : prev - 1
                  )
                }
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "50%",
                  bgcolor: "rgba(0,0,0,0.6)",
                  color: "#fff",
                  "&:hover": { bgcolor: "rgba(0,0,0,0.75)" },
                }}
              >
                <East sx={{ transform: "rotate(180deg)" }} />
              </IconButton>
              <IconButton
                aria-label="Next"
                onClick={() =>
                  setRewardsStep((prev) =>
                    prev === rewardsSteps.length - 1 ? 0 : prev + 1
                  )
                }
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "50%",
                  bgcolor: "rgba(0,0,0,0.6)",
                  color: "#fff",
                  "&:hover": { bgcolor: "rgba(0,0,0,0.75)" },
                }}
              >
                <East />
              </IconButton>
            </Box>
          </Box>

          {/* Caption */}
          <Typography
            sx={{
              mt: 2,
              textAlign: "center",
              fontSize: { md: "18px", xs: "16px" },
              fontWeight: 500,
            }}
          >
            {rewardsSteps[rewardsStep].label}
          </Typography>
        </Box>
        <br></br>
        <br></br>
        {/* Layer 3: Trust */}
        <Box sx={{ mt: 6 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mt: 1,
              "& div": {
                fontSize: { md: "22px", sm: "18px" },
                fontWeight: 700,
                color: "#000",
                whiteSpace: "nowrap",
              },
            }}
          >
            <Box
              sx={{ py: 2, px: 3, background: (t) => t.palette.secondary.main }}
            >
              Layer 3 - Trust
            </Box>
          </Box>
          <br></br>
          <Typography
            sx={{
              mt: 2,
              fontWeight: 700,
              fontSize: { md: "22px", xs: "20px" },
            }}
          >
            Workshops → Convert discovery into revenue
          </Typography>
          <Typography
            sx={{
              mt: 1,
              fontSize: { md: "22px", xs: "20px" }, // match size
              fontWeight: 400, // match weight
              color: "#000", // force black
            }}
          >
            Smart filters (age/psychometric), urgency nudges (“Few seats
            left!”), and transparent details for parents.
          </Typography>
          <Box
            sx={{
              mt: 2,
              maxWidth: "900px",
              border: "1px solid #e0e0e0",
              overflow: "hidden",
              "& video": {
                width: "100%",
                height: "auto",
                display: "block",
                objectFit: "contain",
              },
            }}
          >
            <video
              src={WorkshopsVideo} // 👈 import this at top just like other videos
              autoPlay
              loop
              muted
              playsInline
            />
          </Box>

          <br></br>
          <br></br>
          <Typography
            sx={{
              mt: 4,
              fontWeight: 700,
              fontSize: { md: "22px", xs: "20px" },
            }}
          >
            Kid’s Dashboard → Give kids ownership of progress
          </Typography>
          <Typography
            sx={{
              mt: 1,
              fontSize: { md: "22px", xs: "20px" }, // match size
              fontWeight: 400, // match weight
              color: "#000", // force black
            }}
          >
           Track workshops, points, milestones, interests, and referrals in one
            hub.
          </Typography>
         
          <Box
            sx={{
              mt: 2,
              position: "relative",
              // display: "flex",           // remove
              // justifyContent: "center",  // remove
            }}
          >
            <Box
              sx={{
                maxWidth: "900px",
                width: "100%",
                aspectRatio: "16 / 9",
                border: "1px solid #e0e0e0",
                overflow: "hidden",
                bgcolor: "#fff",
                "& img": {
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  display: "block",
                },
              }}
            >
              <img
                src={kidsDashboardSteps[kidsDashboardStep].img}
                alt={kidsDashboardSteps[kidsDashboardStep].label}
              />
            </Box>

            {/* Arrows bottom-right */}
            <Box
              sx={{
                position: "absolute",
                right: 12,
                bottom: 12,
                display: "flex",
                gap: 1,
              }}
            >
              <IconButton
                aria-label="Previous"
                onClick={() =>
                  setKidsDashboardStep((prev) =>
                    prev === 0 ? kidsDashboardSteps.length - 1 : prev - 1
                  )
                }
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "50%",
                  bgcolor: "rgba(0,0,0,0.6)",
                  color: "#fff",
                  "&:hover": { bgcolor: "rgba(0,0,0,0.75)" },
                }}
              >
                <East sx={{ transform: "rotate(180deg)" }} />
              </IconButton>
              <IconButton
                aria-label="Next"
                onClick={() =>
                  setKidsDashboardStep((prev) =>
                    prev === kidsDashboardSteps.length - 1 ? 0 : prev + 1
                  )
                }
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "50%",
                  bgcolor: "rgba(0,0,0,0.6)",
                  color: "#fff",
                  "&:hover": { bgcolor: "rgba(0,0,0,0.75)" },
                }}
              >
                <East />
              </IconButton>
            </Box>
          </Box>

          {/* Caption */}
          <Typography
            sx={{
              mt: 2,
              textAlign: "center",
              fontSize: { md: "18px", xs: "16px" },
              fontWeight: 500,
            }}
          >
            {kidsDashboardSteps[kidsDashboardStep].label}
          </Typography>
          <br></br>
          <Typography
            sx={{
              mt: 4,
              fontWeight: 700,
              fontSize: { md: "22px", xs: "20px" },
            }}
          >
            Tutor Dashboard → Help educators scale reach
          </Typography>
          <Typography
            sx={{
              mt: 1,
              fontSize: { md: "22px", xs: "20px" }, // match size
              fontWeight: 400, // match weight
              color: "#000", // force black
            }}
          >
            Manage workshops, submissions, schedules, and public profiles.
          </Typography>
        
          <Box
            sx={{
              mt: 2,
              position: "relative",
              // display: "flex",           // remove
              // justifyContent: "center",  // remove
            }}
          >
            <Box
              sx={{
                maxWidth: "900px",
                width: "100%",
                aspectRatio: "16 / 9",
                border: "1px solid #e0e0e0",
                overflow: "hidden",
                bgcolor: "#fff",
                "& img": {
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  display: "block",
                },
              }}
            >
              <img
                src={tutorDashboardSteps[tutorDashboardStep].img}
                alt={tutorDashboardSteps[tutorDashboardStep].label}
              />
            </Box>

            {/* Arrows bottom-right */}
            <Box
              sx={{
                position: "absolute",
                right: 12,
                bottom: 12,
                display: "flex",
                gap: 1,
              }}
            >
              <IconButton
                aria-label="Previous"
                onClick={() =>
                  setTutorDashboardStep((prev) =>
                    prev === 0 ? tutorDashboardSteps.length - 1 : prev - 1
                  )
                }
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "50%",
                  bgcolor: "rgba(0,0,0,0.6)",
                  color: "#fff",
                  "&:hover": { bgcolor: "rgba(0,0,0,0.75)" },
                }}
              >
                <East sx={{ transform: "rotate(180deg)" }} />
              </IconButton>
              <IconButton
                aria-label="Next"
                onClick={() =>
                  setTutorDashboardStep((prev) =>
                    prev === tutorDashboardSteps.length - 1 ? 0 : prev + 1
                  )
                }
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "50%",
                  bgcolor: "rgba(0,0,0,0.6)",
                  color: "#fff",
                  "&:hover": { bgcolor: "rgba(0,0,0,0.75)" },
                }}
              >
                <East />
              </IconButton>
            </Box>
          </Box>

          {/* Caption */}
          <Typography
            sx={{
              mt: 2,
              textAlign: "center",
              fontSize: { md: "18px", xs: "16px" },
              fontWeight: 500,
            }}
          >
            {tutorDashboardSteps[tutorDashboardStep].label}
          </Typography>
        </Box>
      </SectionEightWrapper>

      {/* Landing page callout */}
      <Box
        sx={{
          mt: 8,
          width: "95%",
          mx: "auto",
          "& img": {
            maxWidth: "1536px",
            width: "100%",
            borderRadius: "12px",
            boxShadow: "4px 0px 20px 0px #66666640",
          },
        }}
      ></Box>

      {/* Impact */}
      <SectionSeventeenWrapper id="section4">
        <Typography
          variant="h3"
          sx={{
            fontSize: { md: "40px", sm: "32px", xs: "28px" },
            fontWeight: 700,
            fontFamily: "Mohave",
            fontStyle: "italic",
            width: "fit-content",
          }}
        >
          IMPACT
        </Typography>

        <Box
          sx={{
            py: 3.5,
            px: 4,
            mt: 4,
            mb: 6,
            background: (theme: Theme) => theme.palette.secondary.main,
            width: "fit-content",
          }}
        >
          <Typography
            sx={{
              fontSize: { md: "22px", xs: "18px" },
              fontWeight: 600,
              lineHeight: "33.89px",
              color: "#000",
            }}
          >
            Within the first few months of launch, ZillSkill saw:<br></br>
            <ul>
              <li>
                50% month-over-month growth in users, driven by word-of-mouth
                among kids and parents. (Measured Jan '21 - Mar '21)
              </li>
              <li>
                Kids who took the psychometric test were 2.3× more likely to
                enroll in a workshop than those who only browsed.
              </li>
              <li>
                Usage patterns showed kids completing challenges and revisiting
                the platform multiple times per week - strong signals that we
                were moving toward our key metric of sustaining a 7-day repeat
                rate.
              </li>
            </ul>
          </Typography>
        </Box>

        <Typography
          sx={{ fontSize: { md: "22px", xs: "20px" }, fontWeight: 600 }}
        >
          What this project reinforced for me:
        </Typography>

        <Box sx={{ mt: 3 }}>
          <Box sx={{ display: "flex", alignItems: "flex-start", mt: 2 }}>
            <East sx={{ color: "#00C853" }} /> {/* brighter green arrow */}
            <Typography
              sx={{
                ml: 1,
                fontSize: { md: "20px", xs: "18px" },
                color: "#000",
              }}
            >
              <b>Exploration vs. Academics:</b> Kids thrive when discovery feels
              like play.
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "flex-start", mt: 2 }}>
            <East sx={{ color: "#00C853" }} /> {/* brighter green arrow */}
            <Typography
              sx={{
                ml: 1,
                fontSize: { md: "20px", xs: "18px" },
                color: "#000",
              }}
            >
              <b>Gamification with intent:</b> Streaks/rewards work when tied to
              real progress.
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "flex-start", mt: 2 }}>
            <East sx={{ color: "#00C853" }} /> {/* brighter green arrow */}
            <Typography
              sx={{
                ml: 1,
                fontSize: { md: "20px", xs: "18px" },
                color: "#000",
              }}
            >
              <b>Parents are stakeholders:</b> Trust and transparency are as
              critical as kid engagement.
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "flex-start", mt: 2 }}>
            <East sx={{ color: "#00C853" }} /> {/* brighter green arrow */}
            <Typography
              sx={{
                ml: 1,
                fontSize: { md: "20px", xs: "18px" },
                color: "#000",
              }}
            >
              <b>Designing for kids ≠ adults:</b> Attention spans, encouragement
              loops, and safety require a different playbook.
            </Typography>
          </Box>
        </Box>
      </SectionSeventeenWrapper>
    </ProjectWrapper>
  );
};

export default withAuth(Project4);